const bedroomRangeOptionItems = [
  {
    value: [0, 1],
    label: 'Studio',
  },
  {
    value: [1, 2, 3, 4],
    label: '1+',
  },
  {
    value: [2, 3, 4],
    label: '2+',
  },
  {
    value: [3, 4],
    label: '3+',
  },
  {
    value: [4],
    label: '4+',
  },
];

export default bedroomRangeOptionItems;
